import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {Asset} from '../assets/asset.model';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatFormField, MatFormFieldModule} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {Collection} from "../collection/collection.model";
import {MatOption} from "@angular/material/select";
import {TranslatePipe} from '@ngx-translate/core';
import {CollectionService} from '../collection/collection.service';
import {debounceTime, distinctUntilChanged, Subscription} from 'rxjs';
import {MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger} from '@angular/material/autocomplete';
import {OrderBy} from "../assets/order-by";
import {AddToCollectionResult} from "./add-to-collection-result";

@Component({
    selector: 'app-add-to-collection',
    imports: [
        MatDialogTitle,
        MatIcon,
        MatIconButton,
        MatDialogContent,
        ReactiveFormsModule,
        MatFormField,
        MatInput,
        MatFormFieldModule,
        MatButton,
        MatOption,
        TranslatePipe,
        MatAutocompleteTrigger,
        MatAutocomplete
    ],
    templateUrl: './add-to-collection.component.html',
    styleUrl: './add-to-collection.component.scss'
})
export class AddToCollectionComponent implements OnInit, OnDestroy {

    assets: Asset[] = [];
    collections: Collection[] = [];
    selectedCollection: Collection | undefined;

    addToCollectionForm: FormGroup;
    showAddNewCollection = false;

    searchSubscription: Subscription | undefined;
    submitted: boolean = false;
    error: string = '';

    constructor(public ref: MatDialogRef<AddToCollectionComponent, AddToCollectionResult>,
                @Inject(MAT_DIALOG_DATA) public data: { assets: Asset[], collections: Collection[], initNew?: boolean },
                private fb: FormBuilder,
                private collectionService: CollectionService) {
        this.assets = data.assets
        this.addToCollectionForm = fb.group({
            search: ['', []],
            collectionId: ['', [Validators.required]],
        })
        if (data.initNew) {
            this.showAddNewCollectionForm();
        }
    }

    ngOnInit() {
        if (this.assets && this.assets.length > 0) {
            this.addToCollectionForm.patchValue({
                title: this.assets[0].title,
            })
        }
        this.searchSubscription = this.addToCollectionForm.controls['search'].valueChanges
            .pipe(
                debounceTime(500),
                distinctUntilChanged()
            ).subscribe(searchCollection => {
                if (typeof searchCollection === 'string') {
                    this.getCollections(searchCollection);
                }
            });
        this.getMyCollections();
    }

    getCollections(searchTerm: string) {
        this.collectionService.getCollections(undefined, 'write', searchTerm, OrderBy.created, 'desc', 1, 10).subscribe(collections => {
            this.collections = collections.data;
        })
    }

    getMyCollections() {
        this.collectionService.getCollections('my', 'write', '', OrderBy.created, 'desc', 1, 10).subscribe(collections => {
            this.collections = collections.data;
        })
    }

    selectCollection(e: MatAutocompleteSelectedEvent) {
        const col: Collection = e.option.value;
        this.selectedCollection = col;
        this.addToCollectionForm.patchValue({
            collectionId: col.uuid
        })
    }

    displayFn(coll: Collection) {
        return coll && coll.name ? coll.name : '';
    }

    showAddNewCollectionForm() {
        this.showAddNewCollection = true;
        this.addToCollectionForm.removeControl('collectionId');
        this.addToCollectionForm.addControl('title', this.fb.control('', [Validators.required]));
        this.addToCollectionForm.addControl('description', this.fb.control('', []));
    }

    confirm() {
        this.submitted = true;

        const value = this.addToCollectionForm.value
        let assetIds = this.assets.map(a => a.uuid);

        if (value.collectionId) {
            this.collectionService.addAssetsToCollection(value.collectionId, assetIds).subscribe({
                next: () => {
                    this.ref.close({
                        collection: this.selectedCollection!!,
                        created: false,
                    });
                },
                error: (error) => {
                    this.error = 'collection.addasset.error';
                },
                complete: () => {
                    this.submitted = false;
                }
            });
        } else {
            this.collectionService.createCollection({
                name: value.title,
                description: value.description,
                assets: assetIds
            }).subscribe({
                next: (col) => {
                    this.ref.close({
                        collection: col,
                        created: true,
                    });
                },
                error: (error) => {
                   // console.error('Error adding to collection', error);
                    this.error = 'collections.new.error';
                },
                complete: () => {
                    this.submitted = false;
                }
            });
        }
    }

    close(): void {
        this.ref.close();
    }

    ngOnDestroy() {
        if (this.searchSubscription) {
            this.searchSubscription.unsubscribe();
        }
    }
}
